module.exports = __webpack_public_path__ + "img/baggage.ad41b3b0.png";